import React from 'react'
import { DINING_METHOD, DINING_METHOD_OPTIONS } from '@common'

const CartSummary = ({ assistantInfo, totalAmount }) => {
    const getDiningMethodText = () => {
        if (assistantInfo?.diningMethod === DINING_METHOD.DineIn) {
            return ''
        } else {
            return 'Takeaway'
        }

        return DINING_METHOD_OPTIONS.find(option => option.value === assistantInfo?.diningMethod)?.label || 'Unknown'
    }

    const getTableName = () => {
        if (assistantInfo?.diningMethod === DINING_METHOD.DineIn) {
            return `Table #${assistantInfo?.tableName || '  Unknown'}`
        }
        return ''
    }

    return (
        <div className="border-top border-2 border-secondary pt-4" style={{ flex: '0 0 auto' }}>
            <div className="d-flex justify-content-between">
                <div className="text-start">
                    <div className="fw-bold" style={{ fontSize: '2.5rem' }}>
                        {getDiningMethodText()} {getTableName()}
                    </div>
                </div>
                <div className="text-end">
                    <div className="fw-bold" style={{ fontSize: '2.5rem' }}>
                        Total: $ {totalAmount?.toFixed(2)}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CartSummary
